"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.ColumnChooser = void 0;
var R = __importStar(require("ramda"));
var react_1 = __importStar(require("react"));
var ButtonWithDropdown_1 = require("../ButtonWithDropdown");
var Button_1 = require("../Button");
var Form_1 = require("../Form");
var ViewColumnIcon_1 = __importDefault(require("mdi-react/ViewColumnIcon"));
var CloseIcon_1 = __importDefault(require("mdi-react/CloseIcon"));
var MagnifyIcon_1 = __importDefault(require("mdi-react/MagnifyIcon"));
require("./ColumnChooser.css");
var classnames_1 = __importDefault(require("classnames"));
var ColumnChooser = function (_a) {
    var columns = _a.columns, _b = _a.columnChooserHeader, columnChooserHeader = _b === void 0 ? 'Choose Columns' : _b, _c = _a.selectAllText, selectAllText = _c === void 0 ? 'Select All' : _c, _d = _a.noMatchFoundMessage, noMatchFoundMessage = _d === void 0 ? 'No matches found' : _d, _e = _a.applyButtonText, applyButtonText = _e === void 0 ? 'Apply' : _e, _f = _a.cancelButtonText, cancelButtonText = _f === void 0 ? 'Cancel' : _f, _g = _a.resetButtonText, resetButtonText = _g === void 0 ? 'Reset' : _g, onApply = _a.onApply, className = _a.className, restProps = __rest(_a, ["columns", "columnChooserHeader", "selectAllText", "noMatchFoundMessage", "applyButtonText", "cancelButtonText", "resetButtonText", "onApply", "className"]);
    columns.sort(function (firstObject, secondObject) {
        return firstObject.label.localeCompare(secondObject.label);
    });
    var _h = (0, react_1.useState)(false), expanded = _h[0], setExpanded = _h[1];
    var _j = (0, react_1.useState)(''), search = _j[0], setSearch = _j[1];
    var defaultSelectedColumns = columns
        .filter(function (column) { return column.isSelected; })
        .map(function (column) { return column.key; });
    var defaultSelectedColumnsSet = new Set(__spreadArray([], defaultSelectedColumns, true));
    var _k = (0, react_1.useState)(defaultSelectedColumnsSet), selectedColumns = _k[0], setSelectedColumns = _k[1];
    var _l = (0, react_1.useState)(defaultSelectedColumnsSet), userSelectedColumns = _l[0], setUserSelectedColumns = _l[1];
    var searchedColumns = R.filter(function (_a) {
        var label = _a.label;
        return R.includes(search.toLocaleLowerCase(), label.toLocaleLowerCase());
    }, columns);
    var isAllColumnSelected = columns.length === userSelectedColumns.size;
    var toggleExpanded = function (isExpanded) {
        if (!isExpanded) {
            setSearch('');
        }
        setExpanded(isExpanded);
    };
    var closeHandler = function () {
        setUserSelectedColumns(selectedColumns);
        setSearch('');
        setExpanded(false);
    };
    var applyHandler = function () {
        setSearch('');
        setExpanded(false);
        var userSelectedColumnSet = new Set(__spreadArray([], Array.from(userSelectedColumns), true));
        onApply(userSelectedColumnSet);
    };
    var resetHandler = function () {
        var resetSelectedColumns = new Set(__spreadArray([], defaultSelectedColumns, true));
        setUserSelectedColumns(resetSelectedColumns);
    };
    var addSelection = function (key) {
        setUserSelectedColumns(function (prevState) {
            return new Set(__spreadArray(__spreadArray([], Array.from(prevState), true), [key], false));
        });
    };
    var removeSelection = function (key) {
        setUserSelectedColumns(function (prevState) {
            return new Set(__spreadArray([], Array.from(prevState), true).filter(function (x) { return x !== key; }));
        });
    };
    var selectAllHandler = function () {
        if (isAllColumnSelected) {
            columns.forEach(function (_a) {
                var key = _a.key;
                return removeSelection(key);
            });
        }
        else {
            columns.forEach(function (_a) {
                var key = _a.key;
                return addSelection(key);
            });
        }
    };
    var columnListHandler = function (metric) {
        if (userSelectedColumns.has(metric)) {
            removeSelection(metric);
        }
        else {
            addSelection(metric);
        }
    };
    var compareSets = function (firstSet, secondSet) {
        if (firstSet.size !== secondSet.size) {
            return false;
        }
        return Array.from(secondSet).every(function (element) {
            return firstSet.has(element);
        });
    };
    (0, react_1.useEffect)(function () {
        var isSetEqual = compareSets(userSelectedColumns, selectedColumns);
        if (!isSetEqual) {
            var userSelectedColumnSet = new Set(__spreadArray([], Array.from(userSelectedColumns), true));
            setSelectedColumns(userSelectedColumnSet);
        }
    }, [expanded]);
    return (columns.length > 0 && (react_1["default"].createElement(ButtonWithDropdown_1.ButtonWithDropdown, __assign({ className: "vs-column-chooser" }, restProps, { expanded: expanded, id: "column-chooser", renderButton: function (_a) {
            var _ = _a.expanded, props = __rest(_a, ["expanded"]);
            return (react_1["default"].createElement(Button_1.Button, __assign({ id: "column-chooser-button", type: "icon" }, props, { onClick: function (_) {
                    return toggleExpanded(!expanded);
                } }),
                react_1["default"].createElement(ViewColumnIcon_1["default"], null)));
        } }),
        react_1["default"].createElement("div", { className: (0, classnames_1["default"])('vs-column-chooser-container', className) },
            react_1["default"].createElement("div", { className: "vs-column-chooser-header" },
                react_1["default"].createElement("h3", null, columnChooserHeader),
                react_1["default"].createElement(Button_1.Button, { type: "icon", id: "close-button", onClick: closeHandler },
                    react_1["default"].createElement(CloseIcon_1["default"], null))),
            react_1["default"].createElement("div", { className: "vs-column-chooser-search" },
                react_1["default"].createElement(MagnifyIcon_1["default"], { className: "vs-column-chooser-searchIcon" }),
                react_1["default"].createElement(Form_1.Input, { value: search, placeholder: "Search", id: "search", onChange: function (e) { return setSearch(e.target.value); } })),
            react_1["default"].createElement("div", { id: 'column-list' },
                search === '' && (react_1["default"].createElement("div", null,
                    react_1["default"].createElement(Form_1.Input, { type: "checkbox", id: "select-all", checked: userSelectedColumns.size > 0 ? isAllColumnSelected : false, onChange: selectAllHandler }),
                    react_1["default"].createElement("label", { htmlFor: "select-all" }, selectAllText))),
                searchedColumns.length === 0 ? (react_1["default"].createElement("div", { className: "vs-column-chooser-no-match-found" }, noMatchFoundMessage)) : (searchedColumns.map(function (_a, index) {
                    var metric = _a.key, label = _a.label;
                    return (react_1["default"].createElement("div", { key: index, className: "vs-column-chooser-list-option" },
                        react_1["default"].createElement(Form_1.Input, { type: "checkbox", id: metric, checked: userSelectedColumns.has(metric), onChange: function (_) { return columnListHandler(metric); } }),
                        react_1["default"].createElement("label", { htmlFor: metric }, label)));
                }))),
            react_1["default"].createElement("div", { className: "vs-column-chooser-footer" },
                react_1["default"].createElement("div", { className: "vs-column-chooser-footer-left-segment" },
                    react_1["default"].createElement(Button_1.Button, { type: "text", onClick: resetHandler }, resetButtonText)),
                react_1["default"].createElement("div", { className: "vs-column-chooser-footer-right-segment" },
                    react_1["default"].createElement(Button_1.Button, { type: "text", onClick: closeHandler }, cancelButtonText),
                    react_1["default"].createElement(Button_1.Button, { type: "solid-primary", onClick: applyHandler }, applyButtonText)))))));
};
exports.ColumnChooser = ColumnChooser;
